import { render, staticRenderFns } from "./ImBubbles2Icon.vue?vue&type=template&id=f4a9f8a2"
import script from "./ImBubbles2Icon.vue?vue&type=script&lang=ts"
export * from "./ImBubbles2Icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports